import axios from "axios";

import { authServices } from ".";

const axiosRequestInterceptor = axios.interceptors.request.use(
  async (config) => {
    const { access } = authServices.getTokensFromLocalStorage();
    if (access)
      config.headers.Authorization = `Bearer ${access}`;
    return config;
  },
  (error) => { Promise.reject(error); },
);

const axiosResponseInterceptor = axios.interceptors.response.use(
  (response) => { return response; },
  async (error) => {
    const response = error.response;
    if (response && response.status === 401) {
      const config = error.config;
      const url = new URL(config.url);
      if (url.pathname === "/api/v1/auth/token/refresh/") {
        authServices.clearTokensInLocalStorage();
        window.location = "/";
        return Promise.reject(error);
      }
      if (url.pathname !== "/api/v1/auth/token/" && !config._retry) {
        config._retry = true;
        const { refresh } = authServices.getTokensFromLocalStorage();
        try {
          const response = await authServices.refreshAccessToken(refresh);
          const data = response.data;
          const { access } = data;
          authServices.updateTokensInLocalStorage(access, null);
          return axios(config);
        } catch (error) {
          authServices.clearTokensInLocalStorage();
          window.location = "/";
          return Promise.reject(error);
        }
      } else {
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  },
);

export const axiosServices = {
  axiosRequestInterceptor,
  axiosResponseInterceptor,
};